import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_course_copy_drawer",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "course_copy_drawer",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_course_copy_drawer_button",
  "data-kt-drawer-close": "#kt_drawer_course_copy_drawer_close",
  "data-kt-drawer-width": "75.5vw"
}
const _hoisted_2 = {
  id: "kt_course_copy_drawer",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_course_copy_drawer_header\"><h3 class=\"card-title fw-bolder text-light\" style=\"font-size:1.35rem !important;\"> Course Info </h3><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_course_copy_drawer_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_course_copy_drawer_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_course_copy_drawer_body",
  "data-kt-scroll-dependencies": "#kt_course_copy_drawer_header, #kt_course_copy_drawer_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = { class: "card-body p-2" }
const _hoisted_7 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_course_copy_drawer_scroll"
}
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "card mb-5 mb-xl-10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#create_entity",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Course Info")
  ])
], -1)
const _hoisted_11 = {
  id: "create_entity",
  class: "collapse show"
}
const _hoisted_12 = { class: "collapse show" }
const _hoisted_13 = { class: "card-body border-top p-5" }
const _hoisted_14 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-md-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Association", -1)
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Contract", -1)
const _hoisted_23 = { class: "row mt-3" }
const _hoisted_24 = { class: "col-md-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Type", -1)
const _hoisted_26 = ["label", "value"]
const _hoisted_27 = { class: "col-md-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Skill Level", -1)
const _hoisted_29 = { class: "col-md-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Category", -1)
const _hoisted_31 = ["label", "value"]
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Sector", -1)
const _hoisted_34 = ["label", "value"]
const _hoisted_35 = { class: "row mt-3" }
const _hoisted_36 = { class: "col-md-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Unique Course Name", -1)
const _hoisted_38 = ["label", "value"]
const _hoisted_39 = { class: "col-md-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Course Name")
], -1)
const _hoisted_41 = { class: "col-md-4" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Code")
], -1)
const _hoisted_43 = { class: "row mt-3" }
const _hoisted_44 = { class: "col-md-4" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Target Batch")
], -1)
const _hoisted_46 = { class: "col-md-4" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Batch Size")
], -1)
const _hoisted_48 = { class: "col-md-4" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Minimum Day per month")
], -1)
const _hoisted_50 = { class: "row mt-3" }
const _hoisted_51 = { class: "col-md-4" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Total Target Trainee")
], -1)
const _hoisted_53 = { class: "col-md-4" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Unit Cost", -1)
const _hoisted_55 = { class: "col-md-4" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Total Course Cost", -1)
const _hoisted_57 = { class: "row mt-3" }
const _hoisted_58 = { class: "col-md-4" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Min Age")
], -1)
const _hoisted_60 = { class: "col-md-4" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Max Age")
], -1)
const _hoisted_62 = { class: "col-md-4" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Grace(M)", -1)
const _hoisted_64 = { class: "row mt-3" }
const _hoisted_65 = { class: "col-md-2" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Month")
], -1)
const _hoisted_67 = { class: "col-md-2" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Hour")
], -1)
const _hoisted_69 = { class: "col-md-2" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Day")
], -1)
const _hoisted_71 = { class: "col-md-2" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Session")
], -1)
const _hoisted_73 = { class: "col-md-4" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Term")
], -1)
const _hoisted_75 = { class: "row mt-3" }
const _hoisted_76 = { class: "col-md-6" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Course Objective")
], -1)
const _hoisted_78 = { class: "col-md-6" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Entry Qualification")
], -1)
const _hoisted_80 = { class: "row mt-3" }
const _hoisted_81 = { class: "col-md-12" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Certification Authority")
], -1)
const _hoisted_83 = { class: "row mt-3 p-5" }
const _hoisted_84 = { class: "col-md-2" }
const _hoisted_85 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Is Stipend Course? ", -1)
const _hoisted_87 = { class: "col-md-2" }
const _hoisted_88 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Is Management Course? ", -1)
const _hoisted_90 = { class: "col-md-2" }
const _hoisted_91 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Is Employment Eligible? ", -1)
const _hoisted_93 = { class: "col-md-2" }
const _hoisted_94 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Is Reassessment Enabled? ", -1)
const _hoisted_96 = { class: "col-md-2" }
const _hoisted_97 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Is ToT Course ? ", -1)
const _hoisted_99 = { class: "card mb-5 mb-xl-10" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#course_term",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Course Term")
  ])
], -1)
const _hoisted_101 = {
  id: "course_term",
  class: "collapse show"
}
const _hoisted_102 = { class: "collapse show" }
const _hoisted_103 = { class: "card-body border-top p-5" }
const _hoisted_104 = { class: "row" }
const _hoisted_105 = { class: "col-md-1" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Term ", -1)
const _hoisted_107 = { class: "col-md-2" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Month ", -1)
const _hoisted_109 = { class: "col-md-1" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Day", -1)
const _hoisted_111 = { class: "col-md-1" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Session", -1)
const _hoisted_113 = { class: "col-md-2" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Hour", -1)
const _hoisted_115 = { class: "col-md-2" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Class Type", -1)
const _hoisted_117 = { class: "col-md-2" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Session Per Week", -1)
const _hoisted_119 = { class: "card mb-5 mb-xl-10" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#course_configuration",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Course Configuration ")
  ])
], -1)
const _hoisted_121 = {
  id: "course_configuration",
  class: "collapse show"
}
const _hoisted_122 = { class: "collapse show" }
const _hoisted_123 = { class: "card-body border-top p-5" }
const _hoisted_124 = { "data-kt-stepper-element": "content" }
const _hoisted_125 = { class: "row" }
const _hoisted_126 = { class: "col-md-4" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Enrollment Grace (day)")
], -1)
const _hoisted_128 = { class: "col-md-4" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Dropout %")
], -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, " dropout % for assessment ", -1)
const _hoisted_131 = { class: "col-md-4" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Replacement %")
], -1)
const _hoisted_133 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, " % of dropout replacement by new trainee ", -1)
const _hoisted_134 = { class: "row mt-3" }
const _hoisted_135 = { class: "col-md-4" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Employment Bill Claim %")
], -1)
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, " % of employment required for claim. ", -1)
const _hoisted_138 = { class: "col-md-3 mt-3 p-5" }
const _hoisted_139 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Assessment Applicable? ", -1)
const _hoisted_141 = { class: "col-md-3 mt-3 p-5" }
const _hoisted_142 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Certification Applicable? ", -1)
const _hoisted_144 = { class: "card mb-5 mb-xl-10" }
const _hoisted_145 = {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#course_bill_configuration",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_146 = /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Course Bill Configuration ")
], -1)
const _hoisted_147 = { class: "card-title m-0" }
const _hoisted_148 = { class: "col-md-1" }
const _hoisted_149 = { class: "form-label d-flex" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-primary" }, "Contribution Percentage", -1)
const _hoisted_151 = {
  key: 0,
  class: "badge badge-warning"
}
const _hoisted_152 = {
  key: 1,
  class: "badge badge-warning"
}
const _hoisted_153 = {
  id: "course_bill_configuration",
  class: "collapse show"
}
const _hoisted_154 = { class: "collapse show" }
const _hoisted_155 = { class: "card-body border-top p-5" }
const _hoisted_156 = { "data-kt-stepper-element": "content" }
const _hoisted_157 = { class: "row mt-2" }
const _hoisted_158 = { class: "col-md-2" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Claim", -1)
const _hoisted_160 = { class: "col-md-3" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Milestone ", -1)
const _hoisted_162 = ["onUpdate:modelValue"]
const _hoisted_163 = /*#__PURE__*/_createElementVNode("option", {
  value: "1",
  label: "Enrollment"
}, "Enrollment", -1)
const _hoisted_164 = /*#__PURE__*/_createElementVNode("option", {
  value: "2",
  label: "Certification"
}, "Certification", -1)
const _hoisted_165 = /*#__PURE__*/_createElementVNode("option", {
  value: "3",
  label: "Employement"
}, "Employement", -1)
const _hoisted_166 = [
  _hoisted_163,
  _hoisted_164,
  _hoisted_165
]
const _hoisted_167 = { class: "col-md-2" }
const _hoisted_168 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Claim%", -1)
const _hoisted_169 = { class: "col-md-3" }
const _hoisted_170 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Advance Adjustment %", -1)
const _hoisted_171 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "badge badge-primary" }, "Claim Cost")
  ])
], -1)
const _hoisted_172 = { class: "col-md-1" }
const _hoisted_173 = { class: "form-label" }
const _hoisted_174 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_175 = {
  key: 1,
  class: "badge badge-success"
}
const _hoisted_176 = {
  class: "py-5 text-center",
  id: "kt_course_copy_drawer_footer"
}
const _hoisted_177 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_course_copy_drawer_cancel",
  class: "btn btn-secondary me-5"
}, " Discard ", -1)
const _hoisted_178 = ["data-kt-indicator"]
const _hoisted_179 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_180 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_181 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_182 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            onSubmit: _cache[50] || (_cache[50] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                  _hoisted_17,
                                  _hoisted_18,
                                  _createVNode(_component_el_select, {
                                    class: "form-select-solid",
                                    placeholder: "Select Tranche",
                                    modelValue: _ctx.formData.tranche,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.tranche) = $event)),
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranche, (trans) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: trans.id,
                                          label: trans.label,
                                          value: trans.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(trans.label), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  _hoisted_20,
                                  _createVNode(_component_el_select, {
                                    class: "form-select-solid",
                                    placeholder: "Select Association",
                                    modelValue: _ctx.formData.entity_id,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.entity_id) = $event)),
                                    filterable: "",
                                    style: {"width":"100%"},
                                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getContactList()))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.association, (data) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: data.id,
                                          label: data.entity_short_name,
                                          value: data.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(data.entity_name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "entity_id",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                  _hoisted_22,
                                  _createVNode(_component_el_select, {
                                    class: "form-select-solid",
                                    placeholder: "Select Contract",
                                    modelValue: 
                                    this.formData.entity_tranche_contract_id
                                  ,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((
                                    this.formData.entity_tranche_contract_id
                                  ) = $event)),
                                    filterable: "",
                                    style: {"width":"100%"},
                                    onChange: _cache[4] || (_cache[4] = ($event: any) => (
                                    _ctx.getContractPercentage(
                                      this.formData.entity_tranche_contract_id
                                    )
                                  ))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactList, (data) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: data.id,
                                          label: data.contract_name,
                                          value: data.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(data.contract_name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "entity_tranche_contract_id",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                  _hoisted_25,
                                  _withDirectives(_createElementVNode("select", {
                                    class: "form-select form-select-lg mb-3",
                                    placeholder: "Select Course Type",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.course_type) = $event)),
                                    filterable: "",
                                    style: {"width":"100%"},
                                    selected: ""
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (data) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: data.id,
                                        label: data.type_name,
                                        value: data.id
                                      }, _toDisplayString(data.type_name), 9, _hoisted_26))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _ctx.formData.course_type]
                                  ]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "course_type",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_27, [
                                  _hoisted_28,
                                  _createVNode(_component_el_select, {
                                    class: "form-select-solid",
                                    placeholder: "Select Skill Level",
                                    modelValue: _ctx.formData.skill_level_id,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.skill_level_id) = $event)),
                                    filterable: "",
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skillLevelList, (data) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: data.id,
                                          label: data.name,
                                          value: data.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(data.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "skill_level_id",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                  _hoisted_30,
                                  _withDirectives(_createElementVNode("select", {
                                    class: "form-select form-select-lg mb-3",
                                    placeholder: "Select Course Category",
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.course_category) = $event)),
                                    filterable: "",
                                    style: {"width":"100%"},
                                    name: "course_category",
                                    selected: ""
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (data) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: data.id,
                                        label: data.category_name,
                                        value: data.id
                                      }, _toDisplayString(data.category_name), 9, _hoisted_31))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _ctx.formData.course_category]
                                  ]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "course_category",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _hoisted_33,
                                  _withDirectives(_createElementVNode("select", {
                                    class: "form-select form-select-lg mb-3",
                                    placeholder: "Select Course Sector",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.course_sector) = $event)),
                                    filterable: "",
                                    style: {"width":"100%"},
                                    name: "course_sector",
                                    selected: ""
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectorList, (data) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: data.id,
                                        label: data.sector_name,
                                        value: data.id
                                      }, _toDisplayString(data.sector_name), 9, _hoisted_34))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _ctx.formData.course_sector]
                                  ]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "course_sector",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                  _hoisted_37,
                                  _withDirectives(_createElementVNode("select", {
                                    class: "form-select form-select-lg mb-3",
                                    placeholder: "Select Unique Course",
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.x_course_name_id) = $event)),
                                    filterable: "",
                                    style: {"width":"100%"},
                                    name: "course_alias",
                                    selected: ""
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseAlias, (data) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: data.id,
                                        label: data.name,
                                        value: data.id
                                      }, _toDisplayString(data.name), 9, _hoisted_38))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _ctx.formData.x_course_name_id]
                                  ]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "x_course_name_id",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_39, [
                                  _hoisted_40,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.course_name,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.course_name) = $event)),
                                    name: "course_name",
                                    class: "form-control"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "course_name",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                  _hoisted_42,
                                  _createVNode(_component_Field, {
                                    name: "entity_name",
                                    class: "form-control",
                                    modelValue: _ctx.formData.code,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.code) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "code",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("div", _hoisted_44, [
                                  _hoisted_45,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.total_target_batches,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.total_target_batches) = $event)),
                                    name: "total_target_batches",
                                    class: "form-control",
                                    value: ""
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "total_target_batches",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_46, [
                                  _hoisted_47,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.trainee_per_batch,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.trainee_per_batch) = $event)),
                                    name: "trainee_per_batch",
                                    class: "form-control",
                                    value: ""
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "trainee_per_batch",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_48, [
                                  _hoisted_49,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.min_day_per_month,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.min_day_per_month) = $event)),
                                    name: "min_day_per_month",
                                    class: "form-control",
                                    value: ""
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "min_day_per_month",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("div", _hoisted_51, [
                                  _hoisted_52,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.total_target_trainee,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.total_target_trainee) = $event)),
                                    name: "total_target_trainee",
                                    class: "form-control",
                                    onBlur: _cache[16] || (_cache[16] = ($event: any) => (_ctx.totalcourseCost())),
                                    onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.totalcourseCost()))
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "total_target_trainee",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_53, [
                                  _hoisted_54,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.unit_cost_total,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.unit_cost_total) = $event)),
                                    name: "unit_cost_total",
                                    class: "form-control",
                                    onBlur: _cache[19] || (_cache[19] = ($event: any) => (_ctx.totalcourseCost())),
                                    onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.totalcourseCost()))
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "unit_cost_total",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_55, [
                                  _hoisted_56,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.total_course_cost,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.total_course_cost) = $event)),
                                    name: "total_course_cost",
                                    class: "form-control",
                                    disabled: ""
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "total_course_cost",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("div", _hoisted_58, [
                                  _hoisted_59,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.min_age,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.min_age) = $event)),
                                    name: "min_age",
                                    class: "form-control",
                                    disabled: ""
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "min_age",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_60, [
                                  _hoisted_61,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.max_age,
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.max_age) = $event)),
                                    disabled: "",
                                    name: "max_age",
                                    class: "form-control"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_62, [
                                  _hoisted_63,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.age_grace_in_month,
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.age_grace_in_month) = $event)),
                                    disabled: "",
                                    name: "age_grace_in_month",
                                    class: "form-control"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "age_grace_in_month",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_64, [
                                _createElementVNode("div", _hoisted_65, [
                                  _hoisted_66,
                                  _createVNode(_component_Field, {
                                    type: "number",
                                    modelValue: _ctx.formData.month,
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.month) = $event)),
                                    name: "month",
                                    class: "form-control"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "month",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_67, [
                                  _hoisted_68,
                                  _createVNode(_component_Field, {
                                    type: "number",
                                    modelValue: _ctx.formData.hour,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.hour) = $event)),
                                    name: "hour",
                                    class: "form-control"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "hour",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_69, [
                                  _hoisted_70,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.day,
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.day) = $event)),
                                    name: "day",
                                    class: "form-control",
                                    type: "number"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "day",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_71, [
                                  _hoisted_72,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.session,
                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.session) = $event)),
                                    name: "session",
                                    class: "form-control",
                                    type: "number"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "session",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_73, [
                                  _hoisted_74,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.term,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.term) = $event)),
                                    name: "term",
                                    class: "form-control",
                                    value: "",
                                    type: "number",
                                    onBlur: _ctx.courseTermGenerate
                                  }, null, 8, ["modelValue", "onBlur"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "term",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_75, [
                                _createElementVNode("div", _hoisted_76, [
                                  _hoisted_77,
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formData.course_objective) = $event)),
                                    name: "course_objective",
                                    style: {"display":"block","padding":"0.75rem 1rem","font-size":"1.1rem","font-weight":"500","line-height":"1.5","color":"#181c32","background-color":"#ffffff","background-clip":"padding-box","appearance":"none","border-radius":"0.475rem","box-shadow":"none !important","transition":"border-color 0.15s ease-in-out,\r\n                                      box-shadow 0.15s ease-in-out","width":"100%","height":"20vh !important","border":"1px solid #1db78d !important"}
                                  }, null, 512), [
                                    [_vModelText, _ctx.formData.course_objective]
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_78, [
                                  _hoisted_79,
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formData.entry_qualification) = $event)),
                                    name: "entry_qualification",
                                    style: {"display":"block","padding":"0.75rem 1rem","font-size":"1.1rem","font-weight":"500","line-height":"1.5","color":"#181c32","background-color":"#ffffff","background-clip":"padding-box","appearance":"none","border-radius":"0.475rem","box-shadow":"none !important","transition":"border-color 0.15s ease-in-out,\r\n                                      box-shadow 0.15s ease-in-out","width":"100%","height":"20vh !important","border":"1px solid #1db78d !important"}
                                  }, null, 512), [
                                    [_vModelText, _ctx.formData.entry_qualification]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_80, [
                                _createElementVNode("div", _hoisted_81, [
                                  _hoisted_82,
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((
                                    this.formData.certification_authority
                                  ) = $event)),
                                    name: "certification_authority",
                                    rows: "4",
                                    class: "form-control"
                                  }, null, 512), [
                                    [_vModelText, 
                                    this.formData.certification_authority
                                  ]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_83, [
                                _createElementVNode("div", _hoisted_84, [
                                  _createElementVNode("label", _hoisted_85, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      class: "form-check-input",
                                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.stipenchecked) = $event)),
                                      "true-value": "yes",
                                      "false-value": "no",
                                      onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.isStipendCourseCheck($event)))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.stipenchecked]
                                    ]),
                                    _hoisted_86
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_87, [
                                  _createElementVNode("label", _hoisted_88, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.managementchecked) = $event)),
                                      class: "form-check-input",
                                      "true-value": "yes",
                                      "false-value": "no",
                                      onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.isManagementCourseCheck($event)))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.managementchecked]
                                    ]),
                                    _hoisted_89
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_90, [
                                  _createElementVNode("label", _hoisted_91, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.employmentchecked) = $event)),
                                      "true-value": "yes",
                                      "false-value": "no",
                                      type: "checkbox",
                                      class: "form-check-input",
                                      onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.isEmploymentCourseCheck($event)))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.employmentchecked]
                                    ]),
                                    _hoisted_92
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_93, [
                                  _createElementVNode("label", _hoisted_94, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.reassesmentchecked) = $event)),
                                      "true-value": "yes",
                                      "false-value": "no",
                                      type: "checkbox",
                                      class: "form-check-input",
                                      onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.isReassessmentCheck($event)))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.reassesmentchecked]
                                    ]),
                                    _hoisted_95
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_96, [
                                  _createElementVNode("label", _hoisted_97, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.totchecked) = $event)),
                                      "true-value": "yes",
                                      "false-value": "no",
                                      type: "checkbox",
                                      class: "form-check-input",
                                      onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.isToTCheck($event)))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.totchecked]
                                    ]),
                                    _hoisted_98
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_99, [
                    _hoisted_100,
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.terms, (val, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                          _createElementVNode("div", _hoisted_101, [
                            _createElementVNode("div", _hoisted_102, [
                              _createElementVNode("div", _hoisted_103, [
                                _createElementVNode("div", _hoisted_104, [
                                  _createElementVNode("div", _hoisted_105, [
                                    _hoisted_106,
                                    _createVNode(_component_Field, {
                                      type: "number",
                                      value: i + 1,
                                      class: "form-control"
                                    }, null, 8, ["value"])
                                  ]),
                                  _createElementVNode("div", _hoisted_107, [
                                    _hoisted_108,
                                    _createVNode(_component_Field, {
                                      type: "number",
                                      modelValue: val.month,
                                      "onUpdate:modelValue": ($event: any) => ((val.month) = $event),
                                      class: "form-control"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_109, [
                                    _hoisted_110,
                                    _createVNode(_component_Field, {
                                      type: "number",
                                      modelValue: val.day,
                                      "onUpdate:modelValue": ($event: any) => ((val.day) = $event),
                                      class: "form-control"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_111, [
                                    _hoisted_112,
                                    _createVNode(_component_Field, {
                                      type: "number",
                                      modelValue: val.session,
                                      "onUpdate:modelValue": ($event: any) => ((val.session) = $event),
                                      class: "form-control"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_113, [
                                    _hoisted_114,
                                    _createVNode(_component_Field, {
                                      type: "number",
                                      modelValue: val.hour,
                                      "onUpdate:modelValue": ($event: any) => ((val.hour) = $event),
                                      class: "form-control"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_115, [
                                    _hoisted_116,
                                    _createVNode(_component_el_select, {
                                      modelValue: val.class_type,
                                      "onUpdate:modelValue": ($event: any) => ((val.class_type) = $event),
                                      class: "form-select-solid",
                                      placeholder: "Select Class Type",
                                      style: {"width":"100%"},
                                      filterable: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_option, {
                                          label: "Training",
                                          value: "Training"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Training")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_option, {
                                          label: "Internship",
                                          value: "Internship"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Internship")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_117, [
                                    _hoisted_118,
                                    _createVNode(_component_Field, {
                                      type: "number",
                                      modelValue: val.week,
                                      "onUpdate:modelValue": ($event: any) => ((val.week) = $event),
                                      class: "form-control"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_119, [
                    _hoisted_120,
                    _createElementVNode("div", _hoisted_121, [
                      _createElementVNode("div", _hoisted_122, [
                        _createElementVNode("div", _hoisted_123, [
                          _createElementVNode("div", _hoisted_124, [
                            _createElementVNode("div", _hoisted_125, [
                              _createElementVNode("div", _hoisted_126, [
                                _hoisted_127,
                                _createVNode(_component_Field, {
                                  type: "number",
                                  modelValue: this.configuration.e_grace,
                                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((this.configuration.e_grace) = $event)),
                                  name: "e_grace",
                                  class: "form-control"
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_ErrorMessage, {
                                  name: "e_grace",
                                  class: "fv-plugins-message-container invalid-feedback"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_128, [
                                _hoisted_129,
                                _createVNode(_component_Field, {
                                  type: "number",
                                  modelValue: this.configuration.dropout_below_perc,
                                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((this.configuration.dropout_below_perc) = $event)),
                                  name: "dropout_below_perc\t",
                                  class: "form-control"
                                }, null, 8, ["modelValue"]),
                                _hoisted_130,
                                _createVNode(_component_ErrorMessage, {
                                  name: "dropout_below_perc\t",
                                  class: "fv-plugins-message-container invalid-feedback"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_131, [
                                _hoisted_132,
                                _createVNode(_component_Field, {
                                  type: "number",
                                  modelValue: 
                                  this.configuration.dropout_rep_perc_per_batch
                                ,
                                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((
                                  this.configuration.dropout_rep_perc_per_batch
                                ) = $event)),
                                  name: "dropout_rep_perc_per_batch\t",
                                  class: "form-control"
                                }, null, 8, ["modelValue"]),
                                _hoisted_133,
                                _createVNode(_component_ErrorMessage, {
                                  name: "dropout_rep_perc_per_batch\t",
                                  class: "fv-plugins-message-container invalid-feedback"
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_134, [
                              _createElementVNode("div", _hoisted_135, [
                                _hoisted_136,
                                _createVNode(_component_Field, {
                                  type: "number",
                                  modelValue: this.configuration.emp_bill_claim_perc,
                                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((this.configuration.emp_bill_claim_perc) = $event)),
                                  name: "emp_bill_claim_perc",
                                  class: "form-control"
                                }, null, 8, ["modelValue"]),
                                _hoisted_137
                              ]),
                              _createElementVNode("div", _hoisted_138, [
                                _createElementVNode("label", _hoisted_139, [
                                  _createVNode(_component_Field, {
                                    type: "checkbox",
                                    class: "form-check-input",
                                    name: "assessment_applicable",
                                    onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.isAssesmentCheck($event))),
                                    value: "0"
                                  }),
                                  _hoisted_140
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_141, [
                                _createElementVNode("label", _hoisted_142, [
                                  _createVNode(_component_Field, {
                                    type: "checkbox",
                                    class: "form-check-input",
                                    name: "certification_applicable",
                                    onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.isCertificationCheck($event))),
                                    value: "0"
                                  }),
                                  _hoisted_143
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])), [
                    [_directive_loading, _ctx.load]
                  ]),
                  _createElementVNode("div", _hoisted_144, [
                    _createElementVNode("div", _hoisted_145, [
                      _hoisted_146,
                      _createElementVNode("div", _hoisted_147, [
                        _createElementVNode("div", _hoisted_148, [
                          _createElementVNode("label", _hoisted_149, [
                            _hoisted_150,
                            (this.percentageInfo)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_151, _toDisplayString(this.percentageInfo) + "% ", 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_152, " 0% "))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_153, [
                      _createElementVNode("div", _hoisted_154, [
                        _createElementVNode("div", _hoisted_155, [
                          _createElementVNode("div", _hoisted_156, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.bills, (v, i) => {
                              return (_openBlock(), _createElementBlock("div", { key: i }, [
                                _createElementVNode("div", _hoisted_157, [
                                  _createElementVNode("div", _hoisted_158, [
                                    _hoisted_159,
                                    _createVNode(_component_Field, {
                                      modelValue: v.x_claim_milestone_id,
                                      "onUpdate:modelValue": ($event: any) => ((v.x_claim_milestone_id) = $event),
                                      type: "string",
                                      class: "form-control form-control-sm",
                                      disabled: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_160, [
                                    _hoisted_161,
                                    _withDirectives(_createElementVNode("select", {
                                      class: "form-select-solid",
                                      filterable: "",
                                      style: {"width":"100%"},
                                      placeholder: "Select Training Milestone",
                                      "onUpdate:modelValue": ($event: any) => ((v.x_training_milestone_id) = $event),
                                      disabled: ""
                                    }, _hoisted_166, 8, _hoisted_162), [
                                      [_vModelSelect, v.x_training_milestone_id]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_167, [
                                    _hoisted_168,
                                    _createVNode(_component_Field, {
                                      type: "number",
                                      modelValue: v.claim_percentage,
                                      "onUpdate:modelValue": ($event: any) => ((v.claim_percentage) = $event),
                                      class: "form-control form-control-sm"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_169, [
                                    _hoisted_170,
                                    _createVNode(_component_Field, {
                                      type: "number",
                                      modelValue: v.adj_adv_reduction_perc,
                                      "onUpdate:modelValue": ($event: any) => ((v.adj_adv_reduction_perc) = $event),
                                      class: "form-control form-control-sm"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _hoisted_171,
                                  _createElementVNode("div", _hoisted_172, [
                                    _createElementVNode("label", _hoisted_173, [
                                      (v.claim_percentage)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_174, _toDisplayString((
                                        this.unit_cost_total *
                                        (v.claim_percentage / 100)
                                      ).toFixed(2)), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_175, " 00 "))
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.load]
                ])
              ]),
              _createElementVNode("div", _hoisted_176, [
                _hoisted_177,
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "submit",
                  onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.formSubmit()))
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_179, [
                        _createTextVNode(" Submit "),
                        _createElementVNode("span", _hoisted_180, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_181, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_182
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_178)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])), [
        [_directive_loading, _ctx.load]
      ])
    ])
  ])), [
    [_directive_loading, _ctx.load]
  ])
}